import { DestinationStandardMapping } from "../types";

const bingStandardMapping: DestinationStandardMapping = {
  wildcard: {
    propertiesArr: [],
  },
  items: [],
};

// TODO: Hit Bing API and get customer's campaigns
export const getBingStandardMapping = async () => {
  return bingStandardMapping;
};
